export const CASH_REWARDS_ENROLLMENT_STATUS = 'CASH_REWARDS_ENROLLMENT_STATUS';

export const cashRewardsEnrollmentStatusReturned = payload => dispatch =>
  dispatch({
    type: CASH_REWARDS_ENROLLMENT_STATUS,
    payload,
  });
